import { BrowserModule } from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ToastrModule} from 'ngx-toastr';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import {TokenInterceptor} from './authentication/token.interceptor';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import {MatButtonModule} from '@angular/material/button';
import { HomeComponent } from './home/home.component';
import { TngRedirectComponent } from './tng-redirect/tng-redirect.component';
import {LeadFormAppModule} from './lead-form-app/lead-form-app.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {CooperationInvitationModule} from './cooperation-invitation-response/cooperation-invitation.module';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TngRedirectComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatMenuModule,
    MatIconModule,
    MatDialogModule,
    MatSidenavModule,
    MatListModule,
    ToastrModule.forRoot(
      {
        maxOpened: 5,
        preventDuplicates: true,
        countDuplicates: true,
        timeOut: 5000,
        extendedTimeOut: 8000,
        progressBar: true
      }
    ),
    MatToolbarModule,
    MatButtonModule,
    LeadFormAppModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    CooperationInvitationModule
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
